/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import { ofType } from "redux-observable"
import { concat, from, of, zip } from "rxjs"
import { catchError, concatMap, endWith, flatMap, map, mergeAll, mergeMap, startWith, switchMap, take } from "rxjs/operators"

import CONSTANTS from "../../assets/js/Constants"

// API tìm kiếm phương tiện
const searchTransportationEpic = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.TRANSPORTATION.SEARCH),
      mergeMap((action) => {
         const api = async () => {
            let params = ""
            if (action.payload.keyword !== null && action.payload.keyword.trim() !== "")
               params = `?keyword=${action.payload.keyword}&page=${action.payload.page}`
            else params = `?page=${action.payload.page}`
            const transportations = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.TRANSPORTATION.GET_ALL + params)
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.GET_ALL_TRANSPORTATION_OF_ACCOUNT, transportations.data))
            if (transportations.data.data.length)
               arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.SET_CURRENT_TRANSPORTATION, transportations.data.data[0]))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API tìm kiếm phương tiện theo loại phương tiện
const searchTransportationByTypeEpic = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.TRANSPORTATION.SEARCH_BY_TYPE),
      mergeMap((action) => {
         const api = async () => {
            const transportationsWithType = await CONSTANTS.FUNCTION.AXIOS.GET(
               `${CONSTANTS.URL.TRANSPORTATION.GET_BY_TYPE}?car_type_id=${action.payload.car_type_id}`
            )
            const arrayAction = []
            arrayAction.push(
               CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.UPDATE_CURRENT_TRANSPORTATION_WITH_TYPE, {
                  transportationsWithType: transportationsWithType.data.data
               })
            )
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// Lấy chi tiết của phương tiện
const getDetailTransportationEpic = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.TRANSPORTATION.SET_CURRENT_TRANSPORTATION),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []

            const detailTransportation = await CONSTANTS.FUNCTION.AXIOS.GET(
               `${CONSTANTS.URL.TRANSPORTATION.GET_DETAIL_TRANSPORTANTION}?vehicle_id=${action.payload.vehicle_id}`
            )

            const infoTransportation = await CONSTANTS.FUNCTION.AXIOS.GET(
               `${CONSTANTS.URL.TRANSPORTATION.GET_INFO_TRANSPORTANTION}?vehicle_id=${action.payload.vehicle_id}`
            )

            const transportation = { ...detailTransportation.data.data, ...infoTransportation.data.data }
            if (transportation.car_type_id !== "" || transportation.car_type_id !== null) {
               const typeTransportation = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.TRANSPORTATION.GET_TYPE_TRANSPORTATION)

               if (Array.isArray(typeTransportation.data.data)) {
                  const itemTypeTransportation = typeTransportation.data.data.filter((t) => t.id === transportation.car_type_id)
                  if (itemTypeTransportation.length > 0) {
                     const transportationsWithType = await CONSTANTS.FUNCTION.AXIOS.GET(
                        `${CONSTANTS.URL.TRANSPORTATION.GET_BY_TYPE}?car_type_id=${itemTypeTransportation[0].car_type_relative}`
                     )
                     arrayAction.push(
                        CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.UPDATE_CURRENT_TRANSPORTATION_WITH_TYPE, {
                           transportationsWithType: transportationsWithType.data.data
                        })
                     )
                  }
               } else {
                  console.log(`Lỗi EPIC --> transportationEpic -> 90 -> Lỗi trả về dữ liệu`)
               }

               arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TYPE_TRANSPORTATION.SET_TYPE_TRANSPORTATION, typeTransportation.data.data))
               if (Array.isArray(typeTransportation.data.data))
                  typeTransportation.data.data.forEach((typeTrsprt) => {
                     if (transportation.car_type_id === typeTrsprt.id) {
                        transportation.loai_phuong_tien = typeTrsprt.name
                     }
                  })
            } else {
               CONSTANTS.FUNCTION.COMMON.createLog(
                  `From file:transportationEpic---Line:80,Error:Phương tiện cóId=${transportation.id}chưa có id loại phương tiện`
               )
            }
            if (transportation.loai_nhieu_lieu !== "" || transportation.loai_nhieu_lieu !== null) {
               const typeFuelTransportation = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.TRANSPORTATION.GET_FUEL_TRANSPORTANTION)
               arrayAction.push(
                  CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TYPE_FUEL_TRANSPORTATION.SET_TYPE_FUEL_TRANSPORTANTION, typeFuelTransportation.data.data)
               )
               if (Array.isArray(typeFuelTransportation.data.data))
                  typeFuelTransportation.data.data.forEach((fuelTrsprt) => {
                     if (transportation.loai_nhieu_lieu === fuelTrsprt.id_type_nhienlieu) {
                        transportation.ten_nhien_lieu = fuelTrsprt.name_nhienlieu
                     }
                  })
            } else {
               CONSTANTS.FUNCTION.COMMON.createLog(
                  `From file:transportationEpic---Line:80,Error:Phương tiện cóId=${transportation.id}chưa cóid loại nhiên liệu`
               )
            }
            if (transportation.hinh_thuc !== "" || transportation.hinh_thuc !== null) {
               const formTransportation = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.TRANSPORTATION.GET_BUSSINESS_TRANSPORTANTION)
               arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.FORM_TRANSPORTATION.SET_FORM_TRANSPORTANTION, formTransportation.data.data))
               if (Array.isArray(formTransportation.data.data))
                  formTransportation.data.data.forEach((fuelTrsprt) => {
                     if (transportation.hinh_thuc === fuelTrsprt.id_type_kdvt) {
                        transportation.ten_hinh_thuc_kd = fuelTrsprt.name_type_kdvt
                     }
                  })
            } else {
               CONSTANTS.FUNCTION.COMMON.createLog(
                  `From file:transportationEpic---Line:80,Error:Phương tiện cóId=${transportation.id}chưa cóid hình thức kinh doanh vận tải`
               )
            }
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.UPDATE_CURRENT_TRANSPORTATION, transportation))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API update thông tin phương tiện
const updateTransportationInfomation = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.TRANSPORTATION.UPDATE_TRANSPORTATION_INFOMATION),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const updateInfomation = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.TRANSPORTATION.UPDATE_INFOMATION_TRANSPORTATION, action.payload)
            updateInfomation.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, updateInfomation.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, updateInfomation.data.mess))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// Thêm mới thông tin phương tiện
const postTransportationInfomation = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.TRANSPORTATION.POST_TRANSPORTATION_INFOMATION),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const postTransportation = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.TRANSPORTATION.POST_INFOMATION_TRANSPORTATION, action.payload)
            postTransportation.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, postTransportation.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, postTransportation.data.mess))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API xóa phương tiện
const deleteTransportation = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.TRANSPORTATION.DELETE_TRANSPORTATION),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const deleteTransportation = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.TRANSPORTATION.DELETE_TRANSPORTATION, action.payload)

            // Cập nhật total row sau khi xoá/ẩn thành công phương tiện
            arrayAction.push(
               CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.UPDATE_ROW_CURRENT_TRANSPORTATION, state$.value.transportations.total_row - 1)
            )

            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.UPDATE_TRANSPORTATIONS, action.payload))
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, deleteTransportation.data.status))
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, deleteTransportation.data.mess))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
// Road Fee
// Lấy phí đường bộ theo loại phương tiện,
const getDocumentsRoadFee = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.ROAD_FEE.GET_ROAD_FEE),
      mergeMap((action) => {
         const api = async () => {
            let transportation = {}
            const vehicle_id = state$.value.transportations.currentTransportation.id
            if (vehicle_id) {
               const params = `?vehicle_id=${state$.value.transportations.currentTransportation.id}&page=${
                  typeof action.payload.page !== "undefined" ? action.payload.page : 1
               }${typeof action.payload.keyword !== "undefined" ? `&keyword=${action.payload.keyword}` : ""}`

               const documentsRoadFeeTransportation = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.ROAD_FEE.GET_ALL + params)

               const typeOfTranportations = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.TYPE_TRANSPORTATION_ROAD_FEE.GET_ALL)
               const typeAllTranportations = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.TYPE_TRANSPORTATION_ROAD_FEE.GET_BY_TYPE)

               transportation = {
                  documentsRoadFee: {
                     ...documentsRoadFeeTransportation.data,
                     typeOfTranportations: typeOfTranportations.data,
                     typeAllTranportations: typeAllTranportations.data
                  }
               }
            }
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.UPDATE_CURRENT_TRANSPORTATION, transportation))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API lấy chi tiết phí cầu đường
const getRoadFeeDetail = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.ROAD_FEE.GET_ROAD_FEE_BY_ID),
      mergeMap((action) => {
         const api = async () => {
            let transportation = {}
            const vehicle_id = state$.value.transportations.currentTransportation.id
            if (vehicle_id) {
               const roadFeeDetail = await CONSTANTS.FUNCTION.AXIOS.GET(
                  `${CONSTANTS.URL.ROAD_FEE.GET_BY_ID}?vehicle_id=${state$.value.transportations.currentTransportation.id}&id=${action.payload}`
               )

               transportation = {
                  roadFeeDetail: { ...roadFeeDetail.data }
               }
            }
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.UPDATE_CURRENT_TRANSPORTATION, transportation))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API thêm chi phí cầu đường
const addRoadFee = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.ROAD_FEE.ADD_ROAD_FEE),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const addRoadFee = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.ROAD_FEE.POST, action.payload)
            // Reload lại state để cập nhật đăng kiểm vừa thêm mới
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.ROAD_FEE.GET_ROAD_FEE, { keyword: "", page: 1 }))
            addRoadFee.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, addRoadFee.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, addRoadFee.data.mess))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API cập nhật phí cầu đường
const updateRoadFee = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.ROAD_FEE.UPDATE_ROAD_FEE),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const updateRoadFee = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.ROAD_FEE.PUT, action.payload)
            // Reload lại state để cập nhật đăng kiểm vừa cập nhật
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.ROAD_FEE.GET_ROAD_FEE, { keyword: "", page: 1 }))
            updateRoadFee.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, updateRoadFee.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, updateRoadFee.data.mess))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API xóa phí cầu đường
const deleteRoadFee = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.ROAD_FEE.DELETE_ROAD_FEE),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const deleteRoadFee = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.ROAD_FEE.DELETE, action.payload)
            // Reload lại state để cập nhật đăng kiểm vừa xoá
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.ROAD_FEE.GET_ROAD_FEE, { keyword: "", page: 1 }))
            deleteRoadFee.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, deleteRoadFee.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, deleteRoadFee.data.mess))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// Registration Paper
// Lấy danh sách hồ sơ giấy tờ đăng kiểm
const getDocumentsRegistrationPaper = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.REGISTRATION_PAPER.GET_REGISTRATION_PAPER),
      mergeMap((action) => {
         const api = async () => {
            let transportation = {}
            const vehicle_id = state$.value.transportations.currentTransportation.id
            if (vehicle_id) {
               const params = `?vehicle_id=${state$.value.transportations.currentTransportation.id}&page=${
                  typeof action.payload.page !== "undefined" ? action.payload.page : 1
               }${typeof action.payload.keyword !== "undefined" ? `&keyword=${action.payload.keyword}` : ""}`

               const documentsRegistrationPaperTransportation = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.REGISTRATION_PAPER.GET_ALL + params)
               transportation = { documentsRegistrationPaper: documentsRegistrationPaperTransportation.data }
            }
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.UPDATE_CURRENT_TRANSPORTATION, transportation))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API lấy chi giấy tờ đăng kiểm
const getRegistrationPaperDetail = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.REGISTRATION_PAPER.GET_REGISTRATION_PAPER_BY_ID),
      mergeMap((action) => {
         const api = async () => {
            let transportation = {}
            const vehicle_id = state$.value.transportations.currentTransportation.id
            if (vehicle_id) {
               const registrationPaperDetail = await CONSTANTS.FUNCTION.AXIOS.GET(
                  `${CONSTANTS.URL.REGISTRATION_PAPER.GET_BY_ID}?vehicle_id=${state$.value.transportations.currentTransportation.id}&id=${action.payload}`
               )
               transportation = { registrationPaperDetail: registrationPaperDetail.data }
            }
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.UPDATE_CURRENT_TRANSPORTATION, transportation))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API thêm mới HSGT đăng kiểm
const addRegistrationPaper = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.REGISTRATION_PAPER.ADD_REGISTRATION_PAPER),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const addRegistrationPaper = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.REGISTRATION_PAPER.POST, action.payload)
            // Reload lại state để cập nhật đăng kiểm vừa thêm mới
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.REGISTRATION_PAPER.GET_REGISTRATION_PAPER, { keyword: "", page: 1 }))
            addRegistrationPaper.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, addRegistrationPaper.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, addRegistrationPaper.data.mess))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API cập nhật HSGT đăng kiểm
const updateRegistrationPaper = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.REGISTRATION_PAPER.UPDATE_REGISTRATION_PAPER),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const updateRegistrationPaper = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.REGISTRATION_PAPER.PUT, action.payload)
            // Reload lại state để cập nhật đăng kiểm vừa cập nhật
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.REGISTRATION_PAPER.GET_REGISTRATION_PAPER, { keyword: "", page: 1 }))
            updateRegistrationPaper.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, updateRegistrationPaper.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, updateRegistrationPaper.data.mess))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// Xóa HSGT đăng kiểm
const deleteRegistrationPaper = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.REGISTRATION_PAPER.DELETE_REGISTRATION_PAPER),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const deleteRegistrationPaper = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.REGISTRATION_PAPER.DELETE, action.payload)
            // Reload lại state để cập nhật đăng kiểm vừa xoá
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.REGISTRATION_PAPER.GET_REGISTRATION_PAPER, { keyword: "", page: 1 }))
            deleteRegistrationPaper.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, deleteRegistrationPaper.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, deleteRegistrationPaper.data.mess))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// Insurance Paper
// API lấy danh sách bảo hiểm
const getInsurancePaper = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.INSURANCE_PAPER.GET_INSURANCE_PAPER),
      mergeMap((action) => {
         const api = async () => {
            let transportation = {}
            const vehicle_id = state$.value.transportations.currentTransportation.id
            if (vehicle_id) {
               const params = `?vehicle_id=${state$.value.transportations.currentTransportation.id}&page=${
                  typeof action.payload.page !== "undefined" ? action.payload.page : 1
               }${typeof action.payload.keyword !== "undefined" ? `&keyword=${action.payload.keyword}` : ""}`

               const documentsInsurancePaper = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.INSURANCE_PAPER.GET_ALL + params)
               transportation = { documentsInsurancePaper: documentsInsurancePaper.data }
            }
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.UPDATE_CURRENT_TRANSPORTATION, transportation))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API lấy chi tiết bảo hiểm
const getInsurancePaperDetail = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.INSURANCE_PAPER.GET_INSURANCE_PAPER_BY_ID),
      mergeMap((action) => {
         const api = async () => {
            let transportation = {}
            const vehicle_id = state$.value.transportations.currentTransportation.id
            if (vehicle_id) {
               const insurancePaperDetail = await CONSTANTS.FUNCTION.AXIOS.GET(
                  `${CONSTANTS.URL.INSURANCE_PAPER.GET_BY_ID}?vehicle_id=${state$.value.transportations.currentTransportation.id}&id=${action.payload}`
               )
               transportation = { insurancePaperDetail: insurancePaperDetail.data }
            }
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.UPDATE_CURRENT_TRANSPORTATION, transportation))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API thêm mới bảo hiểm
const addInsurancePaper = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.INSURANCE_PAPER.ADD_INSURANCE_PAPER),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const addInsurancePaper = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.INSURANCE_PAPER.POST, action.payload)
            // Reload lại state để cập nhật bảo hiểm vừa thêm mới
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.INSURANCE_PAPER.GET_INSURANCE_PAPER, { keyword: "", page: 1 }))

            addInsurancePaper.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, addInsurancePaper.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, addInsurancePaper.data.mess))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API cập nhật bảo hiểm
const updateInsurancePaper = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.INSURANCE_PAPER.UPDATE_INSURANCE_PAPER),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const updateInsurancePaper = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.INSURANCE_PAPER.PUT, action.payload)
            // Reload lại state để cập nhật bảo hiểm vừa cập nhật
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.INSURANCE_PAPER.GET_INSURANCE_PAPER, { keyword: "", page: 1 }))

            updateInsurancePaper.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, updateInsurancePaper.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, updateInsurancePaper.data.mess))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API xóa bảo hiểm
const deleteInsurancePaper = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.INSURANCE_PAPER.DELETE_INSURANCE_PAPER),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const deleteInsurancePaper = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.INSURANCE_PAPER.DELETE, action.payload)
            // Reload lại state để cập nhật bảo hiểm vừa xoá
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.INSURANCE_PAPER.GET_INSURANCE_PAPER, { keyword: "", page: 1 }))

            deleteInsurancePaper.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, deleteInsurancePaper.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, deleteInsurancePaper.data.mess))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// CarBadges Paper
// API lấy danh sách phù hiệu xe
const getCarBadgesPaper = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.CAR_BADGES_PAPER.GET_CAR_BADGES_PAPER),
      mergeMap((action) => {
         const api = async () => {
            let transportation = {}
            const vehicle_id = state$.value.transportations.currentTransportation.id
            if (vehicle_id) {
               const params = `?vehicle_id=${state$.value.transportations.currentTransportation.id}&page=${
                  typeof action.payload.page !== "undefined" ? action.payload.page : 1
               }${typeof action.payload.keyword !== "undefined" ? `&keyword=${action.payload.keyword}` : ""}`

               const documentsCarBadgesPaper = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.CAR_BADGES_PAPER.GET_ALL + params)
               transportation = { documentsCarBadgesPaper: documentsCarBadgesPaper.data }
            }
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.UPDATE_CURRENT_TRANSPORTATION, transportation))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API lấy chi tiết phù hiệu xe
const getCarBadgesPaperDetail = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.CAR_BADGES_PAPER.GET_CAR_BADGES_PAPER_BY_ID),
      mergeMap((action) => {
         const api = async () => {
            let transportation = {}
            const vehicle_id = state$.value.transportations.currentTransportation.id
            if (vehicle_id) {
               const carBadgesPaperDetail = await CONSTANTS.FUNCTION.AXIOS.GET(
                  `${CONSTANTS.URL.CAR_BADGES_PAPER.GET_BY_ID}?vehicle_id=${state$.value.transportations.currentTransportation.id}&id=${action.payload}`
               )
               transportation = { carBadgesPaperDetail: carBadgesPaperDetail.data }
            }
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.UPDATE_CURRENT_TRANSPORTATION, transportation))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API thêm mới phù hiệu xe
const addCarBadgesPaper = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.CAR_BADGES_PAPER.ADD_CAR_BADGES_PAPER),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const addCarBadgesPaper = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.CAR_BADGES_PAPER.POST, action.payload)
            // Reload lại state để cập nhật phù hiệu vừa thêm mới
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.CAR_BADGES_PAPER.GET_CAR_BADGES_PAPER, { keyword: "", page: 1 }))

            addCarBadgesPaper.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, addCarBadgesPaper.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, addCarBadgesPaper.data.mess))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API cập nhật phù hiệu xe
const updateCarBadgesPaper = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.CAR_BADGES_PAPER.UPDATE_CAR_BADGES_PAPER),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const updateCarBadgesPaper = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.CAR_BADGES_PAPER.PUT, action.payload)
            // Reload lại state để cập nhật phù hiệu vừa cập nhật
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.CAR_BADGES_PAPER.GET_CAR_BADGES_PAPER, { keyword: "", page: 1 }))

            updateCarBadgesPaper.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, updateCarBadgesPaper.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, updateCarBadgesPaper.data.mess))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API cập nhật phù hiệu xe
const deleteCarBadgesPaper = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.CAR_BADGES_PAPER.DELETE_CAR_BADGES_PAPER),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const deleteCarBadgesPaper = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.CAR_BADGES_PAPER.DELETE, action.payload)
            // Reload lại state để cập nhật phù hiệu vừa xoá
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.CAR_BADGES_PAPER.GET_CAR_BADGES_PAPER, { keyword: "", page: 1 }))

            deleteCarBadgesPaper.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, deleteCarBadgesPaper.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, deleteCarBadgesPaper.data.mess))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// Registration Card Paper
// API lấy danh sách đăng ký xe
const getRegistrationCardPaper = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.REGISTRATION_CARD_PAPER.GET_REGISTRATION_CARD_PAPER),
      mergeMap((action) => {
         const api = async () => {
            let transportation = {}
            const vehicle_id = state$.value.transportations.currentTransportation.id
            if (vehicle_id) {
               const params = `?vehicle_id=${state$.value.transportations.currentTransportation.id}&page=${
                  typeof action.payload.page !== "undefined" ? action.payload.page : 1
               }${typeof action.payload.keyword !== "undefined" ? `&keyword=${action.payload.keyword}` : ""}`

               const documentsRegistrationCardPaper = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.REGISTRATION_CARD_PAPER.GET_ALL + params)
               transportation = { documentsRegistrationCardPaper: documentsRegistrationCardPaper.data }
            }
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.UPDATE_CURRENT_TRANSPORTATION, transportation))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
// Lấy chi tiết đăng ký xe
const getRegistrationCardPaperDetail = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.REGISTRATION_CARD_PAPER.GET_REGISTRATION_CARD_PAPER_BY_ID),
      mergeMap((action) => {
         const api = async () => {
            let transportation = {}
            const vehicle_id = state$.value.transportations.currentTransportation.id
            if (vehicle_id) {
               const registrationCardPaperDetail = await CONSTANTS.FUNCTION.AXIOS.GET(
                  `${CONSTANTS.URL.REGISTRATION_CARD_PAPER.GET_BY_ID}?vehicle_id=${state$.value.transportations.currentTransportation.id}&id=${action.payload}`
               )
               transportation = { registrationCardPaperDetail: registrationCardPaperDetail.data }
            }
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.UPDATE_CURRENT_TRANSPORTATION, transportation))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API thêm mới đăng ký xe
const addRegistrationCardPaper = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.REGISTRATION_CARD_PAPER.ADD_REGISTRATION_CARD_PAPER),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const addRegistrationCardPaper = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.REGISTRATION_CARD_PAPER.POST, action.payload)
            // Reload lại state để cập nhật đăng ký xe vừa thêm mới
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.REGISTRATION_CARD_PAPER.GET_REGISTRATION_CARD_PAPER, { keyword: "", page: 1 }))

            addRegistrationCardPaper.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, addRegistrationCardPaper.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, addRegistrationCardPaper.data.mess))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API cập nhật đăng ký xe
const updateRegistrationCardPaper = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.REGISTRATION_CARD_PAPER.UPDATE_REGISTRATION_CARD_PAPER),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const updateRegistrationCardPaper = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.REGISTRATION_CARD_PAPER.PUT, action.payload)
            // Reload lại state để cập nhật đăng ký xe vừa cập nhật
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.REGISTRATION_CARD_PAPER.GET_REGISTRATION_CARD_PAPER, { keyword: "", page: 1 }))
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, updateRegistrationCardPaper.data.status))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API xóa đăng ký xe
const deleteRegistrationCardPaper = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.REGISTRATION_CARD_PAPER.DELETE_REGISTRATION_CARD_PAPER),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const deleteRegistrationCardPaper = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.REGISTRATION_CARD_PAPER.DELETE, action.payload)
            // Reload lại state để cập nhật đăng ký xe vừa xoá
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.REGISTRATION_CARD_PAPER.GET_REGISTRATION_CARD_PAPER, { keyword: "", page: 1 }))

            deleteRegistrationCardPaper.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, deleteRegistrationCardPaper.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, deleteRegistrationCardPaper.data.mess))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// Maintenance transportation
// API lấy danh sách bảo dưỡng xe
const getMaintenanceTransportation = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.MAINTENANCE_TRANSPORTATION.GET_MAINTENANCE_TRANSPORTATION),
      mergeMap((action) => {
         const api = async () => {
            let transportation = {}
            const vehicle_id = state$.value.transportations.currentTransportation.id
            if (vehicle_id) {
               const params = `?vehicle_id=${state$.value.transportations.currentTransportation.id}&page=${
                  typeof action.payload.page !== "undefined" ? action.payload.page : 1
               }${typeof action.payload.keyword !== "undefined" ? `&keyword=${action.payload.keyword}` : ""}`

               const maintenanceTransportation = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.MAINTENANCE_TRANSPORTATION.GET_ALL + params)
               transportation = { maintenanceTransportation: maintenanceTransportation.data }
            }
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.UPDATE_CURRENT_TRANSPORTATION, transportation))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API lấy danh sách bảo dưỡng xe
const getMaintenanceTransportationDetail = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.MAINTENANCE_TRANSPORTATION.GET_MAINTENANCE_TRANSPORTATION_BY_ID),
      mergeMap((action) => {
         const api = async () => {
            let transportation = {}
            const vehicle_id = state$.value.transportations.currentTransportation.id
            if (vehicle_id) {
               const maintenanceTransportationDetail = await CONSTANTS.FUNCTION.AXIOS.GET(
                  `${CONSTANTS.URL.MAINTENANCE_TRANSPORTATION.GET_BY_ID}?vehicle_id=${state$.value.transportations.currentTransportation.id}&id=${action.payload}`
               )
               transportation = { maintenanceTransportationDetail: maintenanceTransportationDetail.data }
            }
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.UPDATE_CURRENT_TRANSPORTATION, transportation))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// Incident transportation
// API lấy danh sách sự cố xe
const getIncidentTransportation = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.INCIDENT_TRANSPORTATION.GET_INCIDENT_TRANSPORTATION),
      mergeMap((action) => {
         const api = async () => {
            let transportation = {}
            const vehicle_id = state$.value.transportations.currentTransportation.id
            if (vehicle_id) {
               const params = `?vehicle_id=${state$.value.transportations.currentTransportation.id}&page=${
                  typeof action.payload.page !== "undefined" ? action.payload.page : 1
               }${typeof action.payload.keyword !== "undefined" ? `&keyword=${action.payload.keyword}` : ""}`

               const incidentTransportation = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.INCIDENT_TRANSPORTATION.GET_ALL + params)
               transportation = { incidentTransportation: incidentTransportation.data }
            }
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.UPDATE_CURRENT_TRANSPORTATION, transportation))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API lấy chi tiết sự cố xe
const getIncidentTransportationDetail = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.INCIDENT_TRANSPORTATION.GET_INCIDENT_TRANSPORTATION_BY_ID),
      mergeMap((action) => {
         const api = async () => {
            let transportation = {}
            const vehicle_id = state$.value.transportations.currentTransportation.id
            if (vehicle_id) {
               const incidentTransportationDetail = await CONSTANTS.FUNCTION.AXIOS.GET(
                  `${CONSTANTS.URL.INCIDENT_TRANSPORTATION.GET_BY_ID}?vehicle_id=${state$.value.transportations.currentTransportation.id}&id=${action.payload}`
               )
               transportation = { incidentTransportationDetail: incidentTransportationDetail.data }
            }
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.UPDATE_CURRENT_TRANSPORTATION, transportation))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API thêm mới Sự cố xe
const addIncidentTransportationEpic = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.INCIDENT_TRANSPORTATION.ADD_INCIDENT_TRANSPORTATION),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const addIncidentTransportation = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.INCIDENT_TRANSPORTATION.POST, action.payload)
            // Reload lại state để cập nhật sự cố vừa thêm mới
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.INCIDENT_TRANSPORTATION.GET_INCIDENT_TRANSPORTATION, { keyword: "", page: 1 }))
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, addIncidentTransportation.data.status))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API cập nhật sự cố xe
const updateIncidentTransportationEpic = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.INCIDENT_TRANSPORTATION.UPDATE_INCIDENT_TRANSPORTATION),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const updateIncidentTransportation = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.INCIDENT_TRANSPORTATION.PUT, action.payload)
            // Reload lại state để cập nhật sự cố vừa cập nhật
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.INCIDENT_TRANSPORTATION.GET_INCIDENT_TRANSPORTATION, { keyword: "", page: 1 }))
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, updateIncidentTransportation.data.status))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API xác nhận xử lý sự cố xe
const proccessIncidentTransportation = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.INCIDENT_TRANSPORTATION.DELETE_INCIDENT_TRANSPORTATION),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const proccessIncident = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.INCIDENT_TRANSPORTATION.DELETE, action.payload)
            // Reload lại state để cập nhật đóng sự cố
            arrayAction.push(
               CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.INCIDENT_TRANSPORTATION.GET_INCIDENT_TRANSPORTATION, {
                  keyword: "",
                  page: 1
               })
            )

            proccessIncident.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, proccessIncident.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, proccessIncident.data.mess))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// Todo Incident transportation
// Lấy danh sách [Sự cố xe]
const getTodoIncidentTransportation = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.TODO_INCIDENT_TRANSPORTATION.GET_TODO_INCIDENT_TRANSPORTATION),
      mergeMap((action) => {
         const api = async () => {
            let transportation = {}
            const vehicle_id = state$.value.transportations.currentTransportation.id
            if (vehicle_id) {
               const todoIncidentTransportation = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.TODO_INCIDENT_TRANSPORTATION.GET_ALL)
               transportation = { todoIncidentTransportation: todoIncidentTransportation.data }
            }
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.UPDATE_CURRENT_TRANSPORTATION, transportation))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// Calendar reminder transportation
// API lấy lịch nhắc phương tiện
const getCalendarReminderTransportation = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.CALENDAR_REMINDER_TRANSPORTATION.GET_CALENDAR_REMINDER_TRANSPORTATION),
      mergeMap((action) => {
         const api = async () => {
            let transportation = {}
            const vehicle_id = state$.value.transportations.currentTransportation.id
            if (vehicle_id) {
               const params = `?vehicle_id=${state$.value.transportations.currentTransportation.id}&page=${
                  typeof action.payload.page !== "undefined" ? action.payload.page : 1
               }${typeof action.payload.keyword !== "undefined" ? `&keyword=${action.payload.keyword}` : ""} ${
                  typeof action.payload.type_issue !== "undefined" ? `&type_issue=${action.payload.type_issue}` : ""
               } ${typeof action.payload.time_issue !== "undefined" ? `&time_issue=${action.payload.time_issue}` : ""}`

               const calenderReminderTransportation = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.CALENDAR_REMINDER_TRANSPORTATION.GET_ALL + params)
               transportation = { calenderReminderTransportation: calenderReminderTransportation.data }
            }
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.UPDATE_CURRENT_TRANSPORTATION, transportation))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API lấy chi tiết lịch nhắc của phương tiện đang focus
const getCalendarReminderTransportationDetail = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.CALENDAR_REMINDER_TRANSPORTATION.GET_CALENDAR_REMINDER_TRANSPORTATION_BY_ID),
      mergeMap((action) => {
         const api = async () => {
            let transportation = {}
            const vehicle_id = state$.value.transportations.currentTransportation.id
            if (vehicle_id) {
               const calenderReminderTransportationDetail = await CONSTANTS.FUNCTION.AXIOS.GET(
                  `${CONSTANTS.URL.CALENDAR_REMINDER_TRANSPORTATION.GET_BY_ID}?vehicle_id=${state$.value.transportations.currentTransportation.id}&id_issue=${action.payload}`
               )
               transportation = { calenderReminderTransportationDetail: calenderReminderTransportationDetail.data }
            }
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.UPDATE_CURRENT_TRANSPORTATION, transportation))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API cập nhật lịch nhắc phương tiện
const updateCalendarReminderTransportationEpic = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.CALENDAR_REMINDER_TRANSPORTATION.UPDATE_CALENDAR_REMINDER_TRANSPORTATION),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const updateCalendarReminderTransportation = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.CALENDAR_REMINDER_TRANSPORTATION.PUT, action.payload)
            // Reload lại state để cập nhật lịch nhắc vừa cập nhật
            arrayAction.push(
               CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.CALENDAR_REMINDER_TRANSPORTATION.GET_CALENDAR_REMINDER_TRANSPORTATION, {
                  keyword: "",
                  page: 1
               })
            )
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, updateCalendarReminderTransportation.data.status))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API bỏ qua lịch nhắc phương tiện
const cancleCalendarReminder = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.CALENDAR_REMINDER_TRANSPORTATION.DELETE_CALENDAR_REMINDER_TRANSPORTATION),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const cancleCalendarReminder = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.CALENDAR_REMINDER_TRANSPORTATION.DELETE, action.payload)
            // Reload lại state để cập nhật lịch nhắc vừa bỏ qua
            arrayAction.push(
               CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.CALENDAR_REMINDER_TRANSPORTATION.GET_CALENDAR_REMINDER_TRANSPORTATION, {
                  keyword: "",
                  page: 1
               })
            )

            cancleCalendarReminder.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, cancleCalendarReminder.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, cancleCalendarReminder.data.mess))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// Todo Calendar reminder transportation
// API lấy danh mục việc Lịch nhắc
const getTodoCalendarReminderTransportation = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.TODO_CALENDAR_REMINDER_TRANSPORTATION.GET_TODO_CALENDAR_REMINDER_TRANSPORTATION),
      mergeMap((action) => {
         const api = async () => {
            let transportation = {}
            const vehicle_id = state$.value.transportations.currentTransportation.id
            if (vehicle_id) {
               const todoCalendarReminderTransportation = await CONSTANTS.FUNCTION.AXIOS.GET(
                  `${CONSTANTS.URL.TODO_CALENDAR_REMINDER_TRANSPORTATION.GET_ALL}?vehicle_maintenance_schedule_detail_id=${action.payload}`
               )
               transportation = { todoCalendarReminderTransportation: todoCalendarReminderTransportation.data }
            }
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.UPDATE_CURRENT_TRANSPORTATION, transportation))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// Cost transportation
// API lấy chi phí của phương tiện
const getCostTransportation = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.COST_TRANSPORTATION.GET_COST_TRANSPORTATION),
      mergeMap((action) => {
         const api = async () => {
            let transportation = {}
            const vehicle_id = state$.value.transportations.currentTransportation.id
            if (vehicle_id) {
               const params = `?vehicle_id=${state$.value.transportations.currentTransportation.id}&type_fee_id=${action.payload.typeFeeId || ""}&from_date=${
                  action.payload.fromDate || ""
               }&to_date=${action.payload.toDate || ""}&page=${action.payload.page || 1}${
                  typeof action.payload.keyword !== "undefined" ? `&keyword=${action.payload.keyword}` : ""
               }`

               // Lấy loại chi phí của phương tiện
               const typeOfFeesTransportation = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.TYPE_OF_FEE_TRANSPORTATION.GET_ALL)

               // Lấy tài xế của phương tiện

               // BUG:  Chỗ này là lấy tất cả danh sách tài xế có trong hệ thống hay chỉ là lấy danh sách tài xế theo account
               // Cách nhận biết mỗi account khác nhau khi gọi chung api (token)=>account => tài xế theo account
               const driversTransportation = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DRIVERS_TRANSPORTATION.GET_ALL)

               const costTransportation = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.COST_TRANSPORTATION.GET_ALL + params)
               transportation = {
                  costTransportation: costTransportation.data,
                  typeOfFeesTransportation: typeOfFeesTransportation.data.data,
                  driversTransportation: driversTransportation.data.data
               }
            }
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.UPDATE_CURRENT_TRANSPORTATION, transportation))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API lấy chi tiết chi phí của phương tiện
const getCostTransportationDetail = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.COST_TRANSPORTATION.GET_COST_TRANSPORTATION_BY_ID),
      mergeMap((action) => {
         const api = async () => {
            let transportation = {}
            const vehicle_id = state$.value.transportations.currentTransportation.id
            if (vehicle_id) {
               // Lấy chi tiết chi phí của phương tiện
               const costTransportationDetail = await CONSTANTS.FUNCTION.AXIOS.GET(
                  `${CONSTANTS.URL.COST_TRANSPORTATION.GET_BY_ID}?vehicle_id=${state$.value.transportations.currentTransportation.id}&id=${action.payload}`
               )

               transportation = {
                  costTransportationDetail: costTransportationDetail.data
               }
            }
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.UPDATE_CURRENT_TRANSPORTATION, transportation))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API thêm mới chi phí phương tiện
const addCostTransportation = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.COST_TRANSPORTATION.ADD_COST_TRANSPORTATION),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const addResponseCost = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.COST_TRANSPORTATION.POST, action.payload)
            // Reload lại state để cập nhật chi phí vừa thêm mới
            arrayAction.push(
               CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.INCIDENT_TRANSPORTATION.GET_INCIDENT_TRANSPORTATION, {
                  keyword: "",
                  typeFeeId: "",
                  fromDate: "",
                  page: 1
               })
            )
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, addResponseCost.data.status))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API cập nhật chi phí phương tiện
const updateCostTransportation = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.COST_TRANSPORTATION.UPDATE_COST_TRANSPORTATION),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const updateCostTransportation = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.COST_TRANSPORTATION.PUT, action.payload)
            // Reload lại state để cập nhật chi phí vừa cập nhật
            arrayAction.push(
               CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.COST_TRANSPORTATION.GET_COST_TRANSPORTATION, {
                  keyword: "",
                  typeFeeId: "",
                  fromDate: "",
                  page: 1
               })
            )
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, updateCostTransportation.data.status))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API xóa chi phí của phương tiện
const deleteCostTransportation = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.COST_TRANSPORTATION.DELETE_COST_TRANSPORTATION),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const deleteCost = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.COST_TRANSPORTATION.DELETE, action.payload)
            // Reload lại state để cập nhật đóng chi phí
            arrayAction.push(
               CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.COST_TRANSPORTATION.GET_COST_TRANSPORTATION, {
                  keyword: "",
                  typeFeeId: "",
                  fromDate: "",
                  page: 1
               })
            )

            deleteCost.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, deleteCost.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, deleteCost.data.mess))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// GET user and Maintenance center provider for Calendar reminder transportation
// API lấy danh sách user thực hiện [lịch nhắc]
const getUserAndMaintananceProviderCalendarReminderTransportation = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.CALENDAR_REMINDER_TRANSPORTATION.GET_USERS_AND_MAINTENANCE_CENTER_PROVIDER_CALENDAR_REMINDER_TRANSPORTATION),
      mergeMap((action) => {
         const api = async () => {
            let transportation = {}
            const vehicle_id = state$.value.transportations.currentTransportation.id
            if (vehicle_id) {
               const usersCalendarReminderTransportation = await CONSTANTS.FUNCTION.AXIOS.GET(`${CONSTANTS.URL.CALENDAR_REMINDER_TRANSPORTATION.GET_USERS}`)
               const maintananceProviderCalendarReminderTransportation = await CONSTANTS.FUNCTION.AXIOS.GET(
                  `${CONSTANTS.URL.CALENDAR_REMINDER_TRANSPORTATION.GET_MAINTANANCE_PROVIDER}`
               )

               transportation = {
                  users: usersCalendarReminderTransportation.data,
                  maintenanceCenterProvider: maintananceProviderCalendarReminderTransportation.data
               }
            }
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.UPDATE_CURRENT_TRANSPORTATION, transportation))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

export default {
   searchTransportationEpic,
   searchTransportationByTypeEpic,
   getDetailTransportationEpic,
   getDocumentsRegistrationPaper,
   getInsurancePaper,
   getRegistrationPaperDetail,
   updateTransportationInfomation,
   deleteTransportation,
   postTransportationInfomation,
   addRegistrationPaper,
   deleteRegistrationPaper,
   updateRegistrationPaper,
   deleteInsurancePaper,
   getInsurancePaperDetail,
   addInsurancePaper,
   updateInsurancePaper,
   getCarBadgesPaper,
   getCarBadgesPaperDetail,
   addCarBadgesPaper,
   updateCarBadgesPaper,
   deleteCarBadgesPaper,
   getRegistrationCardPaper,
   getRegistrationCardPaperDetail,
   addRegistrationCardPaper,
   updateRegistrationCardPaper,
   deleteRegistrationCardPaper,
   getMaintenanceTransportation,
   getMaintenanceTransportationDetail,
   getIncidentTransportation,
   getIncidentTransportationDetail,
   getTodoIncidentTransportation,
   addIncidentTransportationEpic,
   updateIncidentTransportationEpic,
   proccessIncidentTransportation,
   getCalendarReminderTransportation,
   getCalendarReminderTransportationDetail,
   getTodoCalendarReminderTransportation,
   getUserAndMaintananceProviderCalendarReminderTransportation,
   updateCalendarReminderTransportationEpic,
   cancleCalendarReminder,
   getCostTransportation,
   getCostTransportationDetail,
   updateCostTransportation,
   addCostTransportation,
   deleteCostTransportation,
   getDocumentsRoadFee,
   getRoadFeeDetail,
   addRoadFee,
   updateRoadFee,
   deleteRoadFee
}
